import { FunctionComponent } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './paragraph.style';

export interface IProps {
  children: React.ReactNode;
  noMargin?: boolean;
}

const Paragraph: FunctionComponent<IProps> = ({ children, noMargin }) => {
  const styles = componentStyles();

  return (
    <Box mb={noMargin ? 0 : 4} style={styles.wrapper} data-name="paragraph">
      {children}
    </Box>
  );
};

export default Paragraph;
